import React from "react";
import { useLinkedInPosts } from "../hooks/useLinkedInPosts";

const LinkedInPosts: React.FC = () => {
  const { posts, loading, error } = useLinkedInPosts();

  if (loading) {
    return (
      <div className="linkedin-feed">
        <h3>Featured LinkedIn Posts</h3>
        <p>
          <em>Loading...</em>
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="linkedin-feed">
        <h3>Featured LinkedIn Posts</h3>
        <p>
          <em>Unable to load posts.</em>
        </p>
      </div>
    );
  }

  return (
    <div className="linkedin-feed">
      <h3>Featured LinkedIn Posts</h3>
      <div
        className="linkedin-posts-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "1.5rem",
          marginBottom: "1.5rem",
        }}
      >
        {posts.map((post) => (
          <a
            key={post.id}
            href={post.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div
              className="linkedin-post-card"
              style={{
                border: "1px solid #e1e5e9",
                borderRadius: "8px",
                overflow: "hidden",
                cursor: "pointer",
                backgroundColor: "#fff",
                height: "320px",
                display: "flex",
                flexDirection: "column",
              }}
              onMouseOver={(e) => {
                const img = e.currentTarget.querySelector("img");
                if (img) img.style.transform = "scale(1.02)";
              }}
              onMouseOut={(e) => {
                const img = e.currentTarget.querySelector("img");
                if (img) img.style.transform = "scale(1)";
              }}
            >
              <div
                style={{
                  padding: "12px 16px 8px 16px",
                  fontSize: "14px",
                  color: "#666",
                  fontWeight: "500",
                }}
              >
                Post
              </div>

              <div
                style={{
                  padding: "0 16px 12px 16px",
                  fontSize: "16px",
                  fontWeight: "400",
                  lineHeight: "1.4",
                  color: "#000",
                  height: "60px",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                }}
              >
                {post.title}
              </div>

              {post.image && (
                <div style={{ flex: 1, overflow: "hidden" }}>
                  <img
                    src={post.image}
                    alt="Post"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                      transition: "transform 0.6s ease",
                    }}
                  />
                </div>
              )}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default LinkedInPosts;
